import { Routes, Route, Navigate, BrowserRouter, Router } from "react-router-dom";
import { UsuarioRoutes } from "../../usuarios/routes";
import { useAutenticacaoContext } from "../contexts/AutenticacaoContext";
import { AlterarSenha } from "../pages/AlterarSenha";
import { Dashboard } from "../pages/Dashboard";
import { Login } from "./../pages/Login";
import PrivateRoutes from "./PrivateRoutes";
import { PedidosRoutes } from "../../pedidos/routes";
import { FinanceiroRoutes } from "../../financeiro/routes";
import { ProdutosRoutes } from "../../produtos/routes";
import { ClienteRoutes } from "../../clientes/routes";
import { CriarConta } from "../pages/CriarConta";
import { EstabelecimentosRoutes } from "../../estabelecimento/routes";
import { OrganizacaoRoutes } from "../../organizacao/routes";
import { AdminOrganizacoesRoutes } from "../../organizacao/routes/admin";
import { PaginaNaoEncontrada } from "../../pedidos/pages/PaginaNaoEncontrada";
import { NaoAutorizado } from "../../pedidos/pages/NaoAutorizado";
import { MarketplaceRoutes } from "../../marketplace/routes";
import { Layout } from "../components/Layout";
import { ConfiguracoesRoutes } from "../../configuracoes/routes";
import { EntregadoresRoutes } from "../../entregadores/routes";
import { PromocoesRoutes } from "../../promocoes/routes";
import { CozinhaRoutes } from "../../cozinha/routes";
import { useParams } from "react-router-dom";

const RedirectKDSEstacao = () => {
    const { estacaoUuid } = useParams<{ estacaoUuid: string }>();
    return <Navigate to={`/cozinha/painel/${estacaoUuid}`} replace />;
};

export const CoreRoutes = () => {
    const { autenticado, estabelecimento } = useAutenticacaoContext();

    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/criar-conta" element={<CriarConta />} />
            <Route path="/recuperar-senha" element={<AlterarSenha />} />
            <Route path="/estabelecimentos/*" element={<EstabelecimentosRoutes autenticado={autenticado} />} />
            <Route path="/organizacoes/*" element={<OrganizacaoRoutes autenticado={autenticado} />} />
            <Route path="/admin/*" element={<AdminOrganizacoesRoutes autenticado={autenticado} />} />
            <Route path="*" element={<Navigate to="/login" />} />
            <Route element={
                <Layout titulo="Dashboard">
                    <PrivateRoutes
                        autenticado={autenticado}
                    />
                </Layout>
            }>
                <Route path="/dashboard" element={<Dashboard />} />
            </Route>
            <Route path="/usuarios/*" element={<UsuarioRoutes autenticado={autenticado} />} />
            <Route path="/pedidos/*" element={<PedidosRoutes autenticado={autenticado} />} />
            <Route path="/financeiro/*" element={<FinanceiroRoutes autenticado={autenticado} />} />
            <Route path="/cardapio/*" element={<ProdutosRoutes autenticado={autenticado} />} />
            <Route path="/clientes/*" element={<ClienteRoutes autenticado={autenticado} />} />
            <Route path="/configuracoes/*" element={<ConfiguracoesRoutes autenticado={autenticado} />} />
            <Route path="/marketplace/*" element={<MarketplaceRoutes autenticado={autenticado} />} />
            <Route path="/entregadores/*" element={<EntregadoresRoutes autenticado={autenticado} />} />
            <Route path="/promocoes/*" element={<PromocoesRoutes autenticado={autenticado} />} />
            <Route path="/cozinha/*" element={<CozinhaRoutes autenticado={autenticado} />} />
            {/* Redirects de retrocompatibilidade — bookmarks antigos continuam funcionando */}
            <Route path="/kds/expedicao" element={<Navigate to="/cozinha/expedicao" replace />} />
            <Route path="/kds/:estacaoUuid" element={<RedirectKDSEstacao />} />
            <Route path="/pagina-nao-encontrada" element={<PaginaNaoEncontrada />} />
            <Route path="/nao-autorizado" element={<NaoAutorizado />} />
        </Routes>
    );
} 